import { server_ip } from "../config";
export const postUploadImagesAuth = async (path, name, formData, token) => {
    try {
        const response= await fetch(`${server_ip}/api/documents-s3/upload/photo`, {
          method: 'POST',
          body: formData,
          headers: {
            authorization: `Bearer ${token}`,
            folder:path,
            name,
          },
        });
        const json = await response.json();
        return json
    }  catch (error) {
      console.log(error)
        return {errno:1,message:'Unexpected error'}
    }
}
export const postUploadSigatrue = async (path, name, formData, token) => {
    try {
        const response= await fetch(`${server_ip}/api/documents-s3/upload/signiture`, {
          method: 'POST',
          body: formData,
          headers: {
            authorization: `Bearer ${token}`,
            folder:path,
            name,
          },
        });
        const json = await response.json();
        return json
    }  catch (error) {
        return {errno:1,message:'Unexpected error'}
    }
}